import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { Facebook, Instagram, Twitter, Youtube, Mail, Phone, MapPin, Linkedin } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { api } from "@/lib/api";

export const Footer = () => {
    const [settings, setSettings] = useState(null);
    const [contact, setContact] = useState(null);

    useEffect(() => {
        api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
        api.get("/contact").then((r) => setContact(r.data)).catch(() => {});
    }, []);

    const social = settings?.social || {};

    return (
        <footer className="mt-20 border-t border-slate-200 bg-slate-50" data-testid="site-footer">
            <div className="container-x grid gap-10 py-14 md:grid-cols-2 lg:grid-cols-4">
                <div>
                    <div className="flex items-center gap-3">
                        <Logo size={48} />
                        <div>
                            <div className="font-serif text-lg font-semibold text-brand-blue">Gaurav Sankalp</div>
                            <div className="text-[10px] font-medium uppercase tracking-[0.22em] text-slate-500">Phase-1 Association</div>
                        </div>
                    </div>
                    <p className="mt-4 text-sm leading-relaxed text-slate-600">
                        {settings?.footer_text || "Working Together for a Better Community. Registered Co-Operative Housing Societies Association."}
                    </p>
                </div>

                <div>
                    <div className="overline">Explore</div>
                    <ul className="mt-4 space-y-2 text-sm">
                        {[
                            ["About Us", "/about"],
                            ["Our Committee", "/committee"],
                            ["Our Societies", "/societies"],
                            ["Documents", "/documents"],
                            ["Gallery", "/gallery"],
                        ].map(([label, to]) => (
                            <li key={to}>
                                <Link to={to} className="text-slate-600 hover:text-brand-blue" data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}>
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <div className="overline">More</div>
                    <ul className="mt-4 space-y-2 text-sm">
                        {[
                            ["Events", "/events"],
                            ["News & Announcements", "/news"],
                            ["Contact Us", "/contact"],
                            ["Admin Panel", "/admin/login"],
                        ].map(([label, to]) => (
                            <li key={to}>
                                <Link to={to} className="text-slate-600 hover:text-brand-blue">
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <div className="overline">Reach Us</div>
                    <ul className="mt-4 space-y-3 text-sm text-slate-600">
                        <li className="flex gap-3"><MapPin size={16} className="mt-0.5 shrink-0 text-brand-orange" />{contact?.address}</li>
                        <li className="flex gap-3"><Mail size={16} className="mt-0.5 shrink-0 text-brand-orange" /><a href={`mailto:${contact?.email || ""}`} className="hover:text-brand-blue">{contact?.email}</a></li>
                        {contact?.phone && <li className="flex gap-3"><Phone size={16} className="mt-0.5 shrink-0 text-brand-orange" /><a href={`tel:${contact.phone}`} className="hover:text-brand-blue">{contact.phone}</a></li>}
                    </ul>
                    <div className="mt-5 flex items-center gap-3">
                        {social.facebook && <a href={social.facebook} target="_blank" rel="noreferrer" className="rounded-full border border-slate-200 p-2 text-slate-500 hover:text-brand-blue" aria-label="Facebook"><Facebook size={16} /></a>}
                        {social.instagram && <a href={social.instagram} target="_blank" rel="noreferrer" className="rounded-full border border-slate-200 p-2 text-slate-500 hover:text-brand-blue" aria-label="Instagram"><Instagram size={16} /></a>}
                        {social.twitter && <a href={social.twitter} target="_blank" rel="noreferrer" className="rounded-full border border-slate-200 p-2 text-slate-500 hover:text-brand-blue" aria-label="Twitter"><Twitter size={16} /></a>}
                        {social.youtube && <a href={social.youtube} target="_blank" rel="noreferrer" className="rounded-full border border-slate-200 p-2 text-slate-500 hover:text-brand-blue" aria-label="YouTube"><Youtube size={16} /></a>}
                        {social.linkedin && <a href={social.linkedin} target="_blank" rel="noreferrer" className="rounded-full border border-slate-200 p-2 text-slate-500 hover:text-brand-blue" aria-label="LinkedIn"><Linkedin size={16} /></a>}
                    </div>
                </div>
            </div>
            <div className="border-t border-slate-200">
                <div className="container-x flex flex-col items-center justify-between gap-2 py-5 text-xs text-slate-500 md:flex-row">
                    <p>© {new Date().getFullYear()} Gaurav Sankalp Phase-1 Co-Op Housing Societies Association Ltd.</p>
                    <p>Mira Road (East), Thane – 401107</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
